import { c as _c } from "react/compiler-runtime";
import { useSearchPageMapData } from "@/providers/search";
import { useMap } from "@vis.gl/react-google-maps";
import { Loader2 as LoaderCircleIcon } from "lucide-react";
import React from "react";
import { ProjectMarker } from "./project-marker";
export const ProjectMarkers = React.memo(function ProjectMarkers() {
  const $ = _c(13);
  const map = useMap();
  const markers = useSearchPageMapData(_temp);
  let t0;
  if ($[0] !== map) {
    t0 = () => map?.getZoom() ?? 14;
    $[0] = map;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [currentZoom, setCurrentZoom] = React.useState(t0);
  let t1;
  let t2;
  if ($[2] !== map) {
    t1 = () => {
      if (!map) {
        return;
      }
      const zoomListener = map.addListener("zoom_changed", () => {
        const zoom = map.getZoom();
        if (zoom !== undefined) {
          setCurrentZoom(zoom);
        }
      });
      return () => {
        if (zoomListener) {
          zoomListener.remove();
        }
      };
    };
    t2 = [map];
    $[2] = map;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  React.useEffect(t1, t2);
  if (!map) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="absolute inset-0 flex items-center justify-center bg-white/50 z-10"><LoaderCircleIcon className="w-8 h-8 animate-spin text-primary-500" /><span className="ml-2 text-gray-600">Initializing map...</span></div>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== currentZoom || $[7] !== markers) {
    let t4;
    if ($[9] !== currentZoom) {
      t4 = (marker, index) => <ProjectMarker key={`marker-${marker._id?.toString()}-${marker.projectId || index}`} marker={marker} index={index} currentZoom={currentZoom} />;
      $[9] = currentZoom;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = markers.map(t4);
    $[6] = currentZoom;
    $[7] = markers;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <>{t3}</>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
});
function _temp(state) {
  return state.nearByprojects;
}